var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading91_container"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"intern"}),_c('div',{staticClass:"external-shadow"},[_c('div',{staticClass:"central"})])])])
}]

export { render, staticRenderFns }